import {IWishlistRecord} from "./wishlistrecord.interface";

export class Wishlist {
    constructor(
        public cartUserId: number = 0,
        public records: IWishlistRecord[] = [],
    ) {}
}
